<div class="card-container">
@if (evaluatingPermissions()) {
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="cards-wrapper">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>location_on</mat-icon>
          {{ "components.media-input.location-card.header" | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        {{ "components.media-input.location-card.description" | translate }}
      </mat-card-content>
      @if (!currentPosition()) {
        <mat-card-actions>
          <button mat-button (click)="requestGeolocationPermission()">
            {{ "components.media-input.location-card.button" | translate }}
          </button>
        </mat-card-actions>
      }
      @if (currentPosition()) {
        <mat-card-footer class="bottom">
          <mat-icon> done </mat-icon>
          {{
            "components.media-input.location-card.location-received"
              | translate
                : {
                    accuracy: currentPosition()!.coords.accuracy.toFixed(0),
                    sec_ago: secondsAgo(),
                  }
          }}
        </mat-card-footer>
      }
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>perm_camera_mic</mat-icon>
          {{
            "components.media-input.camera-microphone-card.header" | translate
          }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        {{
          "components.media-input.camera-microphone-card.description"
            | translate
        }}
      </mat-card-content>
      @if (!mediaInputService.videoDevices) {
        <mat-card-actions>
          <button mat-button (click)="requestVideoPermission()">
            {{
              "components.media-input.camera-microphone-card.button" | translate
            }}
          </button>
        </mat-card-actions>
      }
      @if (mediaInputService.videoDevices) {
        <div class="bottom">
          <div>
            @if (mediaInputService.videoDevices.length > 1) {
              <mat-form-field>
                <mat-label>
                  {{
                    "components.media-input.camera-microphone-card.camera"
                      | translate
                  }}
                </mat-label>
                <mat-select [(ngModel)]="mediaInputService.selectedVideoDevice">
                  @for (info of mediaInputService.videoDevices; track info) {
                    <div>
                      <mat-option [value]="info.deviceId">{{
                        info.label
                      }}</mat-option>
                    </div>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
          <mat-card-footer>
            <mat-icon> done </mat-icon>
            {{
              "components.media-input.camera-microphone-card.permission-received"
                | translate
                  : {
                      number_cameras: mediaInputService.videoDevices.length,
                    }
            }}
          </mat-card-footer>
        </div>
      }
    </mat-card>
    <button
      mat-stroked-button
      [disabled]="isContinueButtonDisabled"
      (click)="setConfigurationAndNavigate()"
    >
      {{ "components.media-input.apply-changes-button" | translate }}
    </button>
  </div>
}
</div>
